<template>
    <div>
        <v-container v-if="isLoaded" class="business-info-content">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-toolbar flat color="white">
                            <v-btn color="primary" text @click="$router.push({ name: 'businesses' })"><v-icon>keyboard_arrow_left</v-icon>Businesses </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error" class="mr-1" @click="showBusinessDeleteDialog = true">Delete business</v-btn>
                            <v-btn color="primary" outlined class="white--text" @click="$router.push({ name: 'businesses.edit' })">Edit business</v-btn>
                        </v-toolbar>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Στοιχεία καταστήματος</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-list class="chip-item" dense>
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.name') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end"
                                                    ><span style="font-size: medium">{{ businessObject.name }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.price') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <h3 style="font-weight: 500;">
                                                        <span v-for="count in businessObject.price_range" :key="count + 5">&euro;</span>
                                                        <span v-for="count in 4 - businessObject.price_range" :key="count" class="text-muted">&euro;</span>
                                                    </h3>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.phone') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end"
                                                    ><span style="font-size: medium">{{ businessObject.phone }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.score') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end"
                                                    ><span style="font-size: medium">{{ businessObject.score }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.website') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium;" v-if="businessObject.website">
                                                        <a :href="`https://${businessObject.website}`" class="secondary--text" target="_blank">
                                                            www.{{ businessObject.website }}
                                                        </a>
                                                    </span>
                                                    <span v-else>
                                                        -
                                                    </span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.facebook') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium" v-if="businessObject.facebook_url">
                                                        <a :href="`https://facebook.com/${businessObject.facebook_url}`" class="secondary--text" target="_blank">
                                                            {{ businessObject.facebook_url }}
                                                        </a>
                                                    </span>
                                                    <span v-else>
                                                        -
                                                    </span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.instagram') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium" v-if="businessObject.instagram_url">
                                                        <a :href="`https://instagram.com/${businessObject.instagram_url}`" class="secondary--text" target="_blank">
                                                            @{{ businessObject.instagram_url }}
                                                        </a>
                                                    </span>
                                                    <span v-else>
                                                        -
                                                    </span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.email') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium" v-if="businessObject.email">
                                                        {{ businessObject.email }}
                                                    </span>
                                                    <span v-else>
                                                        -
                                                    </span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col :class="{ 'px-2': $vuetify.breakpoint.xsOnly }" cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Τοποθεσία καταστήματος</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-list class="chip-item" dense>
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.country') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end"
                                                    ><span style="font-size: medium">{{ businessObject.country }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.city') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end"
                                                    ><span style="font-size: medium">{{ businessObject.city }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content
                                                    ><span style="font-size: medium">{{ $t('business.address') }}</span>
                                                </v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium;">{{ businessObject.address }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content><span style="font-size: medium">Latitude</span></v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium;">{{ businessObject.latitude }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mx-3" />
                                            <v-list-item>
                                                <v-list-item-content><span style="font-size: medium">Longitude</span></v-list-item-content>
                                                <v-list-item-content class="align-end">
                                                    <span style="font-size: medium;">{{ businessObject.longitude }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col :class="{ 'px-2': $vuetify.breakpoint.xsOnly }" cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Κατηγορίες καταστήματος</h2>
                                    </v-col>
                                </v-row>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-0">
                                    <v-col cols="12">
                                        <v-chip v-for="tagId in businessObject.tags" :key="tagId" class="mr-2 mb-1" color="primary" text-color="white">
                                            {{ getTagsObject[tagId] }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col :class="{ 'px-2': $vuetify.breakpoint.xsOnly }" cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">'Ωρες λειτουργίας</h2>
                                    </v-col>
                                </v-row>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-0">
                                    <v-col cols="12">
                                        <v-list dense v-if="businessObject.hours && businessObject.hours.length > 0">
                                            <div v-for="item in schedule" :key="item.day">
                                                <v-list-item v-if="item.active" class="px-0">
                                                    <v-list-item-action style="min-width:150px;">{{ $t(item.day) }}</v-list-item-action>
                                                    <v-list-item-content style="margin-left:10px; margin-right:10px;">
                                                        <v-text-field
                                                            :label="$t('editBusiness.workingHoursTab.fromTime')"
                                                            v-model="item.fromTime"
                                                            mask="time"
                                                            :disabled="true"
                                                            placeholder="##:##"
                                                            class="disable-events"
                                                        ></v-text-field>
                                                    </v-list-item-content>
                                                    <v-list-item-content style="margin-left:10px; margin-right:10px;">
                                                        <v-text-field
                                                            :label="$t('editBusiness.workingHoursTab.toTime')"
                                                            v-model="item.toTime"
                                                            mask="time"
                                                            :disabled="true"
                                                            placeholder="##:##"
                                                            class="disable-events"
                                                        ></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </div>
                                        </v-list>
                                        <div class="pb-2 px-2" v-else>Δεν υπάρχουν ώρες λειτουργίας για την επιχείρηση</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-row>
                        <v-col :class="{ 'px-2': $vuetify.breakpoint.xsOnly }" cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Φωτογραφίες καταστήματος</h2>
                                    </v-col>
                                </v-row>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pb-4">
                                    <v-col cols="6" sm="4" md="3" xl="2">
                                        <v-hover>
                                            <v-card
                                                slot-scope="{ hover }"
                                                :class="`elevation-${hover ? 2 : 0}`"
                                                @click="uploadImageDialog = true"
                                                flat
                                                tile
                                                class="d-flex add-image-card"
                                            >
                                                <v-icon color="primary" x-large class="add-image-icon">add</v-icon>
                                            </v-card>
                                        </v-hover>
                                    </v-col>
                                    <v-col v-for="(imageInstance, idx) in businessObject.photos" :key="idx" cols="6" sm="4" md="3" xl="2">
                                        <v-hover>
                                            <v-card slot-scope="{ hover }" flat tile class="d-flex image-container">
                                                <v-img :src="imageInstance.image" aspect-ratio="1">
                                                    <v-fade-transition>
                                                        <div v-if="hover" class="d-flex transition-fast-in-fast-out v-card--reveal image-hover" style="height: 100%;">
                                                            <v-row class="button-wrapper">
                                                                <v-col cols="12">
                                                                    <v-btn @click="deleteImage(imageInstance.id, idx)" text icon color="red">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </div>
                                                    </v-fade-transition>
                                                    <template v-slot:placeholder>
                                                        <v-row class="align-center justify-center ma-0">
                                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                            </v-card>
                                        </v-hover>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Εγκαταστάσεις</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.facility_options && businessObject.facility_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.facility_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getFacilityOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Υπηρεσίες</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.service_options && businessObject.service_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.service_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getServiceOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Parking</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.parking_options && businessObject.parking_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.parking_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getParkingOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Κατάλληλο για</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.good_for_options && businessObject.good_for_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.good_for_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getGoodForOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Γεύματα</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.meal_options && businessObject.meal_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.meal_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getMealOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-row :class="{ 'px-2': $vuetify.breakpoint.xsOnly, 'px-4': $vuetify.breakpoint.smAndUp }" class="pt-4">
                                    <v-col cols="12">
                                        <h2 class="title">Επιλογές φαγητού</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="pt-0 px-2">
                                    <v-col cols="12">
                                        <div v-if="businessObject.food_options && businessObject.food_options.length > 0">
                                            <v-chip v-for="itemId in businessObject.food_options" :key="itemId" label class="ma-2" outlined color="#555">
                                                {{ getFoodOptionsObject[itemId] }}
                                            </v-chip>
                                        </div>
                                        <div class="pb-2 px-2 text-muted body-2" v-else>Καμία επιλογή ενεργή!</div>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="uploadImageDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="title">Νέα φωτογραφία</v-card-title>
                <v-card-text class="pt-2">
                    <image-uploader
                        :preview="true"
                        :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                        :capture="false"
                        :debug="1"
                        :autoRotate="false"
                        outputFormat="file"
                        :quality="0.9"
                        @input="setBusinessPhoto"
                    >
                    </image-uploader>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="closeImageDialog()" color="#888888" text>
                        ΑΚΥΡΟ
                    </v-btn>
                    <v-btn @click="uploadCroppedImage()" color="primary" text>
                        ΥΠΟΒΟΛΗ
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog id="businessDeleteDialog" v-model="showBusinessDeleteDialog" width="500" overlay-opacity="0.9" @click:outside="showBusinessDeleteDialog = false">
            <v-card class="pa-3">
                <v-card-title>Are you sure?</v-card-title>
                <v-card-actions class="d-flex justify-end">
                    <v-btn text @click="showBusinessDeleteDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn text color="error" @click="deleteBusiness()">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import { BusinessesApi } from '@/api';
import { dates, fonts, filters } from '@/utils/mixins';

export default {
    name: 'Info',
    mixins: [dates, fonts, filters],
    data() {
        return {
            isLoaded: false,
            uploadImageDialog: false,
            hasImage: false,
            newPhoto: null,
            schedule: [],
            businessObject: {},
            title: 'Image Upload',
            dialog: false,
            businessImage: require('../../../../assets/main.jpg'),
            showBusinessDeleteDialog: false,
        };
    },
    computed: {
        ...mapGetters('BusinessOptions', {
            getTagsObject: 'getTagsObject',
            getServiceOptionsObject: 'getServiceOptionsObject',
            getFacilityOptionsObject: 'getFacilityOptionsObject',
            getParkingOptionsObject: 'getParkingOptionsObject',
            getGoodForOptionsObject: 'getGoodForOptionsObject',
            getMealOptionsObject: 'getMealOptionsObject',
            getFoodOptionsObject: 'getFoodOptionsObject',
        }),
    },
    async created() {
        const { data: businessObject } = await BusinessesApi.get(this.$route.params.id);
        this.businessObject = businessObject;
        if (this.businessObject.profile_picture) {
            this.businessImage = businessObject.profile_picture;
        } else if (this.businessObject.profile_image) {
            this.businessImage = businessObject.profile_image;
        }
        this.schedule = this.formatBusinessHours(this.businessObject);
        this.isLoaded = true;
    },
    methods: {
        setBusinessPhoto(image) {
            this.hasImage = true;
            this.newPhoto = image;
        },
        async deleteImage(imageId, index) {
            try {
                await BusinessesApi.deleteImageUrl(imageId);
                this.businessObject.photos.splice(index, 1);
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η φωτογραφία διαγράφηκε επιτυχώς', color: 'success' });
            } catch (error) {
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η διαγραφή της φωτογραφίας απέτυχε!', color: 'error' });
            }
        },
        async uploadCroppedImage() {
            const formData = new FormData();
            formData.append('image', this.newPhoto, 'image.jpg');
            formData.append('business', this.$route.params.id);
            formData.append('uploaded_by_owner', true);
            const headers = { 'Content-Type': 'multipart/form-data' };
            BusinessesApi.addImageUrl(formData, headers)
                .then(response => {
                    this.businessObject.photos.push(response.data);
                    this.closeImageDialog();
                    this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η φωτογραφία προστέθηκε επιτυχώς', color: 'success' });
                })
                .catch(() => {
                    this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Το ανέβασμα της φωτογραφίας απέτυχε!', color: 'error' });
                });
        },
        closeImageDialog() {
            this.newPhoto = null;
            this.uploadImageDialog = false;
        },
        async deleteBusiness() {
            try {
                await BusinessesApi.delete(this.$route.params.id);
                this.showBusinessDeleteDialog = false;
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η επιχείρηση διαγράφηκε επιτυχώς', color: 'success' });
            } catch (error) {
                this.showBusinessDeleteDialog = false;
                this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Η διαγραφή της επιχείρησης απέτυχε!', color: 'error' });
            }
        },
    },
};
</script>

<style lang="scss">
.text-muted {
    color: #a3a4a6 !important;
}

.section-item {
    margin-left: 10px;
    float: left;
}

.img-preview {
    width: 100%;
}

.fileinput--loaded {
    width: 100%;
}

.business-info-content {
    .add-image-card {
        border: 1px solid #dddddd;
        cursor: pointer;
        width: 100%;
        padding-top: 100%;

        .add-image-icon {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }

    .image-container {
        border: 1px solid #dddddd;
    }

    .image-hover {
        color: white;
        background-color: rgba(255, 255, 255, 0.9);

        .button-wrapper {
            text-align: center;
            align-items: center;
        }
    }
}
</style>
